import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.assign.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Logger from 'js-logger';
import { make } from 'vuex-pathify';
import moment from 'moment';
import { FIB } from "../../config/constants";
import { precacheUrls, clearCaches } from "../../utils/sw";
import { store } from "../../store";
var US = FIB.US; // Use constants for Update States

var defaultState = function defaultState() {
  return {
    questions: [],
    // Storage for downloaded questions
    surveyInProgress: 0,
    // Id of the survey in progress
    surveys: null,
    // Storage for downloaded surveys
    surveysTemp: null,
    // Temporary storage for downloaded questions and surveys
    updateState: US.UNKNOWN // Survey update state

  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Download question and survey data into the store
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} True when successful, false otherwise
   */
  fetchSurveys: function fetchSurveys(_ref) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, dispatch, rootState, state, edges, surveys, surveysData, removeUrls, themeUrls;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, dispatch = _ref.dispatch, rootState = _ref.rootState, state = _ref.state;

              if (rootState.settings.hasConnectivity) {
                _context.next = 5;
                break;
              }

              Logger.warn('Cannot fetch surveys while offline, will retry when online'); // Try again when we're back online

              commit('settings/updateWhenOnline', true, {
                root: true
              });
              return _context.abrupt("return", false);

            case 5:
              // Start the download
              Logger.debug('Start surveys download');
              commit('updateState', US.IN_PROGRESS);
              edges = 'questions,surveys';
              _context.next = 10;
              return _this.$api.fetchSurveys(edges);

            case 10:
              surveys = _context.sent;
              Logger.debug('Download result:', surveys);

              if (!surveys.error) {
                _context.next = 18;
                break;
              }

              Logger.warn('Failed to download surveys');
              commit('updateState', US.PENDING);
              return _context.abrupt("return", false);

            case 18:
              commit('updateState', US.DONE);

            case 19:
              surveysData = surveys.data.surveys; // Save the survey data

              Logger.debug('Save surveys');
              commit('surveysTemp', surveys.data);

              if (!process.env.APP_FOR_WEB) {
                _context.next = 38;
                break;
              }

              if (surveysData.length == 1) {
                store.commit('settings/defaultTemplate', surveysData[0].templateId);
              }

              store.commit('settings/selectedTemplate', rootState.settings.defaultTemplate); // Cache themes from surveys

              removeUrls = [];
              themeUrls = [];
              themeUrls.push(rootState.theme.bgImageSetting);
              surveysData.forEach(function (survey) {
                themeUrls.push(survey.branding.backgroundImage);
                themeUrls.push(survey.branding.logoImage);
                themeUrls.push(survey.branding.headerImage);
              }); // Compare current URLs with previously cached URLs to determine which to clear from cache

              removeUrls.length = 0; // Empty the array

              rootState.config.cachedTheme.forEach(function (url) {
                if (!themeUrls.includes(url)) {
                  removeUrls.push(url);
                }
              }); // Clear cache of old theme urls

              Logger.debug("Removing ".concat(removeUrls.length, " theme url(s) from cache:"), removeUrls);

              if (removeUrls.length) {
                clearCaches(removeUrls);
              } // Pre-cache new/existing theme urls


              Logger.debug("Pre-caching ".concat(themeUrls.length, " theme url(s)"));
              _context.next = 36;
              return precacheUrls(themeUrls.filter(function (x) {
                return x !== null;
              }));

            case 36:
              // Store cached theme urls for comparison next time
              Logger.debug('Cached theme url(s):', themeUrls);
              store.commit('config/cachedTheme', themeUrls);

            case 38:
              // Set last updated timestamp
              commit('config/lastUpdated', moment().unix(), {
                root: true
              }); // Move data out of temporary storage if a survey is not in progress

              if (state.surveysTemp.surveys !== null && !state.surveyInProgress) {
                dispatch('moveData');
              }

              return _context.abrupt("return", true);

            case 41:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Move question and survey data out of temporary storage into main storage.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Void}
   */
  moveData: function moveData(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    if (!state.surveysTemp) {
      Logger.debug('No temporary question or survey data to move');
      return;
    }

    Logger.debug('Move question and survey data out of temporary storage');
    var questions = state.surveysTemp.questions;
    var surveys = state.surveysTemp.surveys;
    commit('surveysTemp', null);
    commit('questions', questions);
    commit('surveys', surveys);
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters

  /**
   * Get the name of a survey.
   *
   * @param {Object} state Vuex module state
   * @param {Number} templateId Template id
   *
   * @returns {String|null} Template name or null
   */
  name: function name(state) {
    return function (templateId) {
      if (state.surveys === null) {
        return null;
      }

      var survey = state.surveys.find(function (survey) {
        return survey.templateId === templateId;
      });
      return survey ? survey.name : null;
    };
  },

  /**
   * Returns true if mailing list subscription enabled.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Boolean} true, if subscription enabled
   */
  subscriptionEnabled: function subscriptionEnabled(state, getters) {
    var _getters$currentSurve, _getters$currentSurve2;

    return ((_getters$currentSurve = getters.currentSurvey) === null || _getters$currentSurve === void 0 ? void 0 : (_getters$currentSurve2 = _getters$currentSurve.dataCapture) === null || _getters$currentSurve2 === void 0 ? void 0 : _getters$currentSurve2.enabled) || false;
  },

  /**
   * Returns currently active survey.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Object} survey object
   */
  currentSurvey: function currentSurvey(state) {
    if (!state.surveys || !state.surveyInProgress) {
      return null;
    }

    return getters.survey(state)(state.surveyInProgress);
  },

  /**
   * Get a summary of template ids and names.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Array}
   */
  summary: function summary(state) {
    if (state.surveys === null) {
      return [];
    }

    return state.surveys.map(function (survey) {
      return {
        name: survey.name,
        templateId: survey.templateId
      };
    });
  },

  /**
   * Get a survey.
   *
   * @param {Object} state Vuex module state
   * @param {Number} templateId Template id - Template ids are unique
   *
   * @returns {Object|null} Survey object or null
   */
  survey: function survey(state) {
    return function (templateId) {
      if (state.surveys === null) {
        return null;
      }

      var survey = state.surveys.find(function (survey) {
        return survey.templateId === templateId;
      });
      return survey || null;
    };
  },

  /**
   * Get a count of the surveys.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Number}
   */
  surveyCount: function surveyCount(state) {
    if (state.surveys === null) {
      return 0;
    }

    return state.surveys.length;
  },

  /**
   * Get questions associated with a given templateId
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Array}
   */
  surveyQuestions: function surveyQuestions(state) {
    return function (templateId) {
      var _state$questions$find;

      return ((_state$questions$find = state.questions.find(function (q) {
        return q.templateId === templateId;
      })) === null || _state$questions$find === void 0 ? void 0 : _state$questions$find.questions) || [];
    };
  },

  /**
   * Get detail associated with a survey questions.
   */
  questionsDetail: function questionsDetail(state) {
    return function (templateId) {
      return state.questions.find(function (q) {
        return q.templateId === templateId;
      }) || {};
    };
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};